/*
export const someAction = (state) => {}
 */

export var setCommonData = function setCommonData(state, data) {
  state.commit('SET_COMMONDATA', data);
};
export var clearCommonData = function clearCommonData(state, data) {
  state.commit('CLEAR_COMMONDATA', data);
};